import React, { Component } from "react"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"

import { ThemeProvider } from "styled-components"
import { Container, theme } from "./styled-components"

import PageHeader from "./partials/PageHeader"
import PageFooter from "./partials/PageFooter"

import ScrollToTop from "./helpers/ScrollToTop"

import Architektur from "./pages/Architektur"
import Datenschutz from "./pages/Datenschutz"
import Events from "./pages/Events"
import Impressionen from "./pages/Impressionen"
import Impressum from "./pages/Impressum"
import Incentives from "./pages/Incentives"
import Koeln from "./pages/Koeln"
import Konzerte from "./pages/Konzerte"
import Messen from "./pages/Messen"
import Page404 from "./pages/Page404"
import Sitemap from "./pages/Sitemap"
import Start from "./pages/Start"
import Tagungen from "./pages/Tagungen"
import Uber from "./pages/Uber"

class App extends Component {
  render() {
    return (
      <div className="App">
        <Router>
          <ScrollToTop>
            <ThemeProvider theme={theme}>
              <Container>
                <PageHeader />
                <Switch>
                  <Route exact path="/" component={Start} />
                  <Route path="/architektur" component={Architektur} />
                  <Route path="/events" component={Events} />
                  <Route path="/incentives" component={Incentives} />
                  <Route path="/konzerte" component={Konzerte} />
                  <Route path="/messen" component={Messen} />
                  <Route path="/impressionen" component={Impressionen} />
                  <Route path="/tagungen" component={Tagungen} />
                  <Route path="/koeln" component={Koeln} />
                  <Route path="/uber" component={Uber} />
                  <Route path="/datenschutz" component={Datenschutz} />
                  <Route path="/impressum" component={Impressum} />
                  <Route path="/sitemap" component={Sitemap} />
                  <Route component={Page404} />
                </Switch>
                <PageFooter />
              </Container>
            </ThemeProvider>
          </ScrollToTop>
        </Router>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js